import { MenuOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    Button,
    Card,
    Col,
    DatePicker,
    Dropdown,
    Form,
    Input,
    Menu,
    Row,
    Select,
    Table,
    Modal,
} from "antd";
import ReviewOrderModal from "../components/ReviewOrderModal.js";
import { useEffect, useState } from "react";
import { fetchData, postData, showError, toLocalDateTime, showSuccess, DateFormat, UserDateTimeFormat } from "../../../utils";
import { useBlockScreen, useRoot } from "../../../rootContext";




// **** ITEM TABLE COLUMNS (Base columns for order items) ****
const itemColumns = [
    {
        title: "SKU",
        dataIndex: "SKU",
        key: "SKU",
        width: 150,
    },
    {
        title: "Product Name",
        dataIndex: "ProductName",
        key: "ProductName",
    },
    {
        title: "Earning",
        dataIndex: "Earning",
        key: "Earning",
        width: 150,
    },
    {
        title: "Quantity",
        dataIndex: "QuantityPurchased",
        key: "QuantityPurchased",
        width: 150,
    },
    {
        title: "Price",
        dataIndex: "ItemPrice",
        key: "ItemPrice",
        width: 150,
    },
    {
        title: "Tax",
        dataIndex: "ItemTax",
        key: "ItemTax",
        width: 150,
    },
];

// **** PARENT TABLE COLUMNS ****
// *** MODIFICATION 1: Remove supplier columns and add buyer data ***
const getColumns = ({ onAction }) => [
    {
        title: "Order ID",
        dataIndex: "OrderId",
        key: "OrderId",
        fixed: "left",
        width: 180,
        sorter: true,
    },
    // Buyer data added here:
    {
        title: "Buyer Email",
        dataIndex: "BuyerEmail",
        key: "BuyerEmail",
        width: 200,
    },
    {
        title: "Buyer Name",
        dataIndex: "BuyerName",
        key: "BuyerName",
        width: 200,
    },
    {
        title: "Order Status",
        dataIndex: "OrderStatus",
        key: "OrderStatus",
        width: 150,
    },
    {
        title: "Order Date",
        dataIndex: "PurchaseDate",
        key: "PurchaseDate",
        width: 180,
        render: (date) => moment(date).format("YYYY-MM-DD"),
    },

    {
        title: "Tracking ID",
        dataIndex: "TrackingId",
        key: "TrackingId",
        width: 150,
    },
    {
        title: "Supplier Order Id",
        dataIndex: "SupplierOrderId",
        key: "SupplierOrderId",
        width: 150,
    },
    {
        title: "PONumber",
        dataIndex: "PONumber",
        key: "PONumber",
        width: 150,
    },
    {
        title: "Supplier",
        dataIndex: "Supplier",
        key: "Supplier",
        width: 150,
    },
    {
        title: "Recipient Name",
        dataIndex: "RecipientName",
        key: "RecipientName",
        width: 200,
    },
    {
        title: "Ship Address 1",
        dataIndex: "ShipAddress1",
        key: "ShipAddress1",
        width: 200,
    },
    {
        title: "Ship Address 2",
        dataIndex: "ShipAddress2",
        key: "ShipAddress2",
        width: 200,
    },
    {
        title: "Ship Address 3",
        dataIndex: "ShipAddress3",
        key: "ShipAddress3",
        width: 200,
    },
    {
        title: "Address Type",
        dataIndex: "AddressType",
        key: "AddressType",
        width: 150,
    },
    {
        title: "Ship City",
        dataIndex: "ShipCity",
        key: "ShipCity",
        width: 150,
    },
    {
        title: "Ship State",
        dataIndex: "ShipState",
        key: "ShipState",
        width: 150,
    },
    {
        title: "Ship Postal Code",
        dataIndex: "ShipPostalCode",
        key: "ShipPostalCode",
        width: 150,
    },
    {
        title: "Ship Country",
        dataIndex: "ShipCountry",
        key: "ShipCountry",
        width: 150,
    },
    {
        title: "Ship Phone Number",
        dataIndex: "ShipPhoneNumber",
        key: "ShipPhoneNumber",
        width: 150,
    },
    {
        title: "Buyer Phone Number",
        dataIndex: "BuyerPhoneNumber",
        key: "BuyerPhoneNumber",
        width: 150,
    },
    {
        title: "Ship Service Level",
        dataIndex: "ShipServiceLevel",
        key: "ShipServiceLevel",
        width: 200,
    },
    {
        title: "Currency",
        dataIndex: "Currency",
        key: "Currency",
        width: 100,
    },
    {
        title: "Shipping Price",
        dataIndex: "ShippingPrice",
        key: "ShippingPrice",
        width: 150,
    },
    {
        title: "Shipping Tax",
        dataIndex: "ShippingTax",
        key: "ShippingTax",
        width: 150,
    },
    {
        title: "Is Buyer Requested Cancellation",
        dataIndex: "IsBuyerRequestedCancellation",
        key: "IsBuyerRequestedCancellation",
        width: 150,
    },
    {
        title: "Buyer Requested Cancel Reason",
        dataIndex: "BuyerRequestedCancelReason",
        key: "BuyerRequestedCancelReason",
        width: 150,
    },
    {
        title: "Action",
        key: "action",
        fixed: "right",
        width: 120,
        render: (_, record) => (
            <Dropdown overlay={menu({ onAction, record })}>
                <Button>
                    <MenuOutlined />
                </Button>
            </Dropdown>
        ),
    },
];


const menu = ({ onAction, record }) => {
    const canPostOrder = record.Items && record.Items.length > 0;

    return (
        <Menu>
            <Menu.Item
                key="post"
                disabled={!canPostOrder}
                onClick={() => onAction({ action: 'POST_ORDER', item: record })}
            >
                Post Order
            </Menu.Item>
            <Menu.Item
                key="Completed"
                onClick={() => onAction({ action: 'Completed', item: record })}
            >
                Mark as Completed
            </Menu.Item>
            <Menu.Item
                key="cancel"
                onClick={() => onAction({ action: 'CANCEL_ORDER', item: record })}
            >
                Mark as Cancelled
            </Menu.Item>
        </Menu>
    );
};



const OpenedOrdersTab = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterData, setFilterData] = useState({
        dateFrom: null,
        dateTo: null,
        orderId: "",
        status: "Open",
    });

    const root = useRoot();
    const blocker = useBlockScreen();
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [cancelModalVisible, setCancelModalVisible] = useState(false);
    const [cancelReason, setCancelReason] = useState("");
    const [orderToCancel, setOrderToCancel] = useState(null);


    // **** Suppliers definition remains (they will be used in the items table) ****
    const suppliers = [
        { name: "Scansource", key: "Ss" },
        { name: "Bluestar", key: "Bs" },
        { name: "Ingram", key: "Ing" },
        //{ name: "Synnex", key: "Snx" },
        //{ name: "VoIP888", key: "Voip" },
        //{ name: "Dandh", key: "Dandh" },
    ];

    useEffect(() => {
        fetchOrders();
    }, [filterData]);


    const handleSearch = () => {
        if (filterData.dateFrom && filterData.dateTo && moment(filterData.dateFrom).isAfter(filterData.dateTo)) {
            showError("Start date cannot be after end date");
            return;
        }
        fetchOrders();
    };

    const fetchOrders = async () => {
        setLoading(true);
        const queryParams = new URLSearchParams();
        if (filterData.dateFrom) queryParams.append("dateFrom", filterData.dateFrom);
        if (filterData.dateTo) queryParams.append("dateTo", filterData.dateTo);
        if (filterData.orderId) queryParams.append("orderIds", filterData.orderId);
        if (filterData.status) queryParams.append("status", filterData.status);
        try {
            const data = await fetchData(`${window.SiteBasePath}/api/OrdersAutomation/SearchOrders?${queryParams.toString()}`);

            const enrichedOrders = await Promise.all(
                data.map(async (order) => {
                    if (!order.Items || order.Items.length === 0) {
                        return order; // No items in the order, return as is
                    }

                    // Fetch quantities for each SKU
                    const updatedItems = await Promise.all(
                        order.Items.map(async (item) => {
                            const supplierQuantities = await getSupplierQuantities(item.SKU);
                            return {
                                ...item,
                                Suppliers: supplierQuantities.Suppliers
                            };
                        })
                    );

                    return { ...order, Items: updatedItems };
                })
            );

            // Sort orders to have those without SupplierOrderId at the top
            const sortedOrders = enrichedOrders.sort((a, b) => {
                if (!a.SupplierOrderId && b.SupplierOrderId) return -1;
                if (a.SupplierOrderId && !b.SupplierOrderId) return 1;
                return 0;
            });

            setOrders(sortedOrders);
        } catch (error) {
            showError("Failed to fetch orders");
        } finally {
            setLoading(false);
        }
    };

    const getSupplierQuantities = async (sku) => {
        if (!sku) {
            console.error("SKU is undefined or empty.");
            return { Suppliers: {} }; // Return structured empty response
        }

        try {
            const response = await fetchData(
                `${window.SiteBasePath}/api/pna/get-quantity/${sku}`,
                {},
                { blocker, root }
            );

            return response || { Suppliers: {} }; // Ensure consistent structure
        } catch (error) {
            console.error("Error fetching quantities:", error);
            return { Suppliers: {} };
        }
    };

    const isOrderInvalid = (order) => {
        console.log(order);
        return order.Items.some(item => {
            return suppliers.every(supplier => {
                const availableQty = item.Suppliers?.[supplier.key]?.Qty ?? 0;
                return item.QuantityPurchased > availableQty;
            });
        });
    };


    const updateOrderStatus = async (order) => {
        setLoading(true);
        try {
            console.log("Updating order status to Completed:", order);
            //check if tracking id and supplierorderid are present
            if (!order.TrackingId || !order.SupplierOrderId) {
                showError("Tracking ID and Supplier Order ID are required to mark order as Completed");
                return;
            }

            const updatedOrder = { ...order, OrderStatus: "Completed" };
            await postData(
                `${window.SiteBasePath}/api/OrdersAutomation/UpdateOrder`,
                updatedOrder,
                { blocker, root }
            );
            showSuccess("Order status updated to Completed");
            fetchOrders();
        } catch (error) {
            showError("Failed to update order status");
        } finally {
            setLoading(false);
        }
    };


    const updateOrderStatusToCancelled = async (order) => {

        try {
            const updatedOrder = { ...order, OrderStatus: "Cancelled" };

            await postData(
                `${window.SiteBasePath}/api/OrdersAutomation/UpdateOrder`,
                updatedOrder,
                { blocker, root }
            );
            setCancelModalVisible(false);
            setCancelReason("");
            showSuccess("Order Cancelled Successfully!!");
        } catch (error) {
            showError("Failed to update order status");
            throw error; // Re-throw to handle in the caller
        } finally {
            setLoading(false);
            setCancelModalVisible(false);
            setCancelReason("");
            setOrderToCancel(null);
        }
    };

    const onOk = async () => {
        if (!cancelReason) {
            showError("Cancellation reason is required.");
            return;
        }
        try {
            await updateOrderStatusToCancelled({
                ...orderToCancel,
                BuyerRequestedCancelReason: cancelReason
            });
            // Refresh the orders list to reflect the cancellation
            await fetchOrders();
        } catch (error) {
            console.error("Error during cancellation:", error);
            showError("Failed to cancel order");
        }
    };



    const handleAction = async ({ action, item, supplier, value }) => {
        switch (action) {
            case 'POST_ORDER':
                console.log("Post Order action triggered for item:", item);
                if (item.IsBuyerRequestedCancellation === true) {
                    showError("You cannot post this order because the buyer has requested cancellation.");
                    return;
                }
                if (item.SupplierOrderId || item.PONumber) {
                    showError("You cannot post this order because this Order is already posted.");
                    return true;
                }
                if (isOrderInvalid(item)) {
                    showError("You cannot post this order because the quantity is not available.");
                    return;
                }
                setSelectedOrder(item);
                setShowReviewModal(true);
                break;
            case 'Completed':
                if (item.IsBuyerRequestedCancellation) {
                    showError("You cannot Mark As Completed this order because the buyer has requested cancellation. You can only cancel it.");
                    return;
                }
                // Handle Completed logic
                await updateOrderStatus(item);
                break;
            case 'CANCEL_ORDER':
                if (item.SupplierOrderId || item.PONumber) {
                    showError("You cannot Cancel this order because this Order is already posted.");
                    return true;
                }

                setOrderToCancel(item);
                setCancelModalVisible(true);
                break;

            default:
                break;
        }
    };


    return (
        <>
            <Card title="Opened Orders" style={{ height: '100%' }}>
                <Form layout="vertical">
                    <Row gutter={16}>
                        <Col span={6}>
                            <Form.Item label="Start Date">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={filterData.dateFrom ? moment(filterData.dateFrom) : ""}
                                    onChange={(date) => {
                                        setFilterData({
                                            ...filterData,
                                            dateFrom: date ? date.format("YYYY-MM-DD") : "",
                                        });
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="End Date">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={filterData.dateTo ? moment(filterData.dateTo) : ""}
                                    onChange={(date) => {
                                        setFilterData({
                                            ...filterData,
                                            dateTo: date ? date.format("YYYY-MM-DD") : "",
                                        });
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Order ID">
                                <Input

                                    value={filterData.orderId}
                                    onChange={(e) => {
                                        setFilterData({
                                            ...filterData,
                                            orderId: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    marginBottom: 0
                                }}
                            >
                                <Button

                                    onClick={handleSearch}
                                >
                                    Refresh
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>


                <div style={{ marginTop: 16 }}>
                    <Table
                        // **** MODIFICATION 2: Use the modified parent columns (buyer data added) ****
                        columns={getColumns({ onAction: handleAction })}
                        dataSource={orders}
                        rowClassName={(record) => isOrderInvalid(record) ? 'red-row' : ''}
                        rowKey="OrderId"
                        loading={loading}
                        scroll={{ x: 'max-content', y: 'calc(100vh - 200px)' }}
                        pagination={{ pageSize: 10 }}
                        style={{ height: "100%" }}
                        expandable={{
                            expandIcon: ({ expanded, onExpand, record }) =>
                                record.Items && record.Items.length > 0 ? (
                                    <Button
                                        type="text"
                                        onClick={(e) => onExpand(record, e)}
                                        icon={expanded ? '-' : '+'}
                                    />
                                ) : null,
                            // **** MODIFICATION 3: In the expanded row, render a nested table with the order’s items plus supplier columns ****
                            expandedRowRender: (record) => {
                                const itemsData = record.Items.map((item) => ({
                                    ...item,
                                    Suppliers: {
                                        ...item.Suppliers,

                                    }
                                }));

                                return (
                                    <Table
                                        columns={[
                                            ...itemColumns,
                                            ...suppliers.map((supplier) => ({
                                                title: supplier.name,
                                                children: [
                                                    {
                                                        title: "Available Qty",
                                                        dataIndex: ["Suppliers", supplier.key, "Qty"],
                                                        key: `${supplier.key}Qty`,
                                                        width: 100,
                                                        render: (qty) => qty ?? 0
                                                    },
                                                    {
                                                        title: "Price",
                                                        dataIndex: ["Suppliers", supplier.key, "Price"],
                                                        key: `${supplier.key}Price`,
                                                        width: 100,
                                                        render: (price) => `$${(price ?? 0).toFixed(2)}`
                                                    }
                                                ]
                                            }))
                                        ]}
                                        dataSource={itemsData}
                                        rowKey="OrderItemId"
                                        pagination={false}
                                    />
                                );


                            },

                            rowExpandable: (record) => record.Items && record.Items.length > 0,
                        }}
                    />
                </div>


                {selectedOrder && (
                    <ReviewOrderModal
                        visible={!!selectedOrder}
                        onCancel={() => setSelectedOrder(null)}
                        order={{
                            ...selectedOrder,
                            Items: selectedOrder.Items.map(item => ({
                                ...item,
                                Suppliers: item.Suppliers || {}
                            }))
                        }}
                        suppliers={suppliers}
                        blocker={blocker}
                        root={root}
                    />
                )}
            </Card>



            <Modal
                title="Cancel Order"
                open={cancelModalVisible}
                onOk={onOk}
                onCancel={() => {
                    setCancelModalVisible(false);
                    setCancelReason("");
                    setOrderToCancel(null);
                }}
            >
                <Input.TextArea
                    rows={4}
                    placeholder="Enter the reason for cancellation"
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                />

            </Modal>


        </>



    );
}
export default OpenedOrdersTab;
